import getApiClient from '@/plugins/api'

export default {
  loadPosts() {
    const api = getApiClient(this.$store)

    api.get('posts')
      .then(result => {
        this.posts = result.data['hydra:member']
      })
  },

  updatePresence() {
    const api = getApiClient(this.$store)
    api.post('presence', {})
      .catch(() => {})
  }
}
